import React from 'react';
import type { ExternalComponentProps } from '../types';
import type { AppInfoBadgeProps as AppInfoBadgeBaseProps } from '../../components/app-info-badge';
import { AppInfoBadge as AppInfoBadgeBase } from '../../components/app-info-badge';
import { withEssentialsContext } from '../../contexts/essentials-context';

export interface AppInfoBadgeProps
  extends ExternalComponentProps,
    AppInfoBadgeBaseProps {}

function AppInfoBadgeComponent({
  isAppInstalled,
  isAppBuiltIn,
  isAppSetupIncomplete,
  isAppWithBenefits,
  pricing,
  options,
  dataHook,
}: AppInfoBadgeProps) {
  return (
    <AppInfoBadgeBase
      isAppBuiltIn={isAppBuiltIn}
      isAppInstalled={isAppInstalled}
      isAppSetupIncomplete={isAppSetupIncomplete}
      isAppWithBenefits={isAppWithBenefits}
      pricing={pricing}
      options={options}
      dataHook={dataHook}
    />
  );
}

export const AppInfoBadge = withEssentialsContext(AppInfoBadgeComponent);
